import IconFullscreen from '@/components/assets/icon_fullscreen.svg'
import ViverseButton from '@/components/ViverseButton'
import { useFullscreen } from '@/hooks/useFullscreen'
import { cn } from '@/lib/utils'

type FullscreenButtonProps = {
  className?: string
  iconClassName?: string
}

export default function FullscreenButton({ className, iconClassName }: FullscreenButtonProps) {
  const { toggleFullscreen } = useFullscreen('standalone-iframe-wrapper')

  return (
    <ViverseButton
      className={cn('group flex min-w-fit gap-2', className)}
      variant="filter"
      onClick={toggleFullscreen}
    >
      <IconFullscreen className={cn('size-[18px]', iconClassName)} />
    </ViverseButton>
  )
}
